import { FileType } from '@citruscamps/citrus-client'

interface IOptions {
  ref: React.RefObject<HTMLImageElement>
  filename: string
  filetype?: FileType
  rotateDegrees: number
  flipX: boolean
  flipY: boolean
}

export const modifyImage = async (options: IOptions): Promise<File | undefined> => {
  const { ref, filename, filetype, flipX, flipY } = options
  if (!ref.current) throw new Error('Failed to modify image')
  const canvas: HTMLCanvasElement = document.createElement('canvas')

  // round to nearest 90 degrees
  const rotateDegrees = Math.round(options.rotateDegrees / 90) * 90

  ref.current.crossOrigin = 'Anonymous'
  const width = ref.current.naturalWidth
  const height = ref.current.naturalHeight
  if (!width || !height) return undefined
  canvas.width = rotateDegrees % 180 === 0 ? width : height
  canvas.height = rotateDegrees % 180 === 0 ? height : width

  const ctx = canvas.getContext('2d')
  if (!ctx) return undefined
  // rotate image
  let posX = 0
  let posY = 0
  if (rotateDegrees) {
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate((rotateDegrees * Math.PI) / 180)
    ctx.translate(-canvas.width / 2, -canvas.height / 2)
    posX = (canvas.width - width) / 2
    posY = (canvas.height - height) / 2
  }

  if (flipX) {
    ctx.translate(width, 0)
    ctx.scale(-1, 1)
  }

  if (flipY) {
    ctx.translate(0, height)
    ctx.scale(1, -1)
  }

  ctx.drawImage(ref.current, posX, posY, width, height)

  const promise = new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, filetype)
  })
  const blob: Blob | null = await promise
  if (!blob) return undefined
  const file: File = new File([blob], filename, { type: blob.type })
  return file
}
